<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      v-bind="attrs"
      type="card, article, actions"
    ></v-skeleton-loader>
    <div v-else>
      <KPIStatistics
        :inspections="inspections"
        :nonConformities="nonConformities"
      />
      <v-row>
        <v-col> <Resume :resume="resume" /></v-col>
      </v-row>
      <v-row>
        <v-col
          xs="12"
          sm="12"
          md="7"
          lg="7"
          xl="7"
        >
          <Overview
            :inspections="inspections"
            :nonConformities="nonConformities"
          />
        </v-col>
        <v-col
          xs="12"
          sm="12"
          md="5"
          lg="5"
          xl="5"
        >
          <PieChart
            :actions="actions"
            :inspections="inspections"
            :nonConformities="nonConformities"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { KPIStatistics, Overview, PieChart, Resume } from "@/components"
import { ReportService } from "@/services"

export default {
  components: {
    KPIStatistics,
    Overview,
    PieChart,
    Resume
  },
  name: "DashboardGeneral",
  props: {
    companyId: { type: Number, required: true },
    mainFilters: {
      type: Object
    }
  },
  data() {
    return {
      actions: [],
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2
      },
      filters: {},
      inspections: [],
      loading: false,
      nonConformities: [],
      resume: {}
    }
  },

  methods: {
    getDatasDashboardProjects() {
      this.loading = true
      ReportService.getDatasDashboardProjects(this, this.companyId, this.filters)
        .then(r => {
          this.actions = r.actions
          this.inspections = r.inspections
          this.nonConformities = r.nonconformities
          this.resume = r.resume
        })
        .finally(() => (this.loading = false))
    },
    handleUpdateFilter(update) {
      this.filters = { ...this.filters, ...update }
      this.getDatasDashboardProjects()
    }
  },
  watch: {
    mainFilters: {
      handler(newValue) {
        this.handleUpdateFilter(newValue)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
